module.exports = __webpack_public_path__ + "static/media/laporan_pembayaran.ac39302f.png";